var _defs, _g, _path, _circle, _circle2, _text, _text2, _rect, _line, _g2, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverwriteTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      @import url('https://fonts.googleapis.com/css2?family=Courier+Prime:wght@700&amp;display=swap');\n\n      .title-text {\n        font-family: 'Courier Prime', 'Courier New', monospace;\n        font-size: 110px;\n        font-weight: 900;\n        text-anchor: middle;\n        letter-spacing: 15px;\n        fill: #eefefe;\n      }\n\n      /* Advanced Filters */\n      .glow { filter: drop-shadow(0 0 5px #06b6d4) drop-shadow(0 0 15px rgba(6, 182, 212, 0.4)); }\n      .distort { filter: url(#wave-distort); }\n      .chromatic { mask: url(#split-mask); }\n\n      /* Diegetic Background Elements */\n      .bg-matrix { font-family: monospace; font-size: 6px; fill: #06b6d4; opacity: 0.15; }\n      .circuit { stroke: #06b6d4; stroke-width: 0.5; fill: none; opacity: 0.1; }\n      \n      /* Animations */\n      @keyframes scroll-binary {\n        from { transform: translateY(0); }\n        to { transform: translateY(-100px); }\n      }\n      @keyframes pulse-circuit {\n        0%, 100% { opacity: 0.05; }\n        50% { opacity: 0.2; }\n      }\n      @keyframes jitter-distort {\n        0% { baseFrequency: 0.01 0.05; }\n        5% { baseFrequency: 0.08 0.15; }\n        10% { baseFrequency: 0.01 0.05; }\n        90% { baseFrequency: 0.01 0.05; }\n        95% { baseFrequency: 0.15 0.02; }\n        100% { baseFrequency: 0.01 0.05; }\n      }\n      @keyframes letter-split {\n        0%, 100% { transform: translate(0, 0); }\n        90% { transform: translate(0, 0); }\n        92% { transform: translate(-15px, 2px); }\n        94% { transform: translate(15px, -2px); }\n        96% { transform: translate(-5px, 5px); }\n      }\n\n      /* Layers */\n      .layer-cyan { fill: #00ffff; mix-blend-mode: screen; animation: letter-split 4s infinite -0.1s; }\n      .layer-red { fill: #ff0000; mix-blend-mode: screen; animation: letter-split 4s infinite -0.2s; }\n      \n      .stutter-slash {\n        stroke: #ef4444; stroke-width: 3; stroke-linecap: square;\n        stroke-dasharray: 1000; stroke-dashoffset: 1000;\n        animation: slash-reveal 3s ease-in-out forwards;\n        filter: drop-shadow(0 0 6px #ef4444);\n      }\n      @keyframes slash-reveal {\n        0% { stroke-dashoffset: 1000; }\n        30% { stroke-dashoffset: 600; }\n        35% { stroke-dashoffset: 650; }\n        60% { stroke-dashoffset: 200; }\n        65% { stroke-dashoffset: 250; }\n        100% { stroke-dashoffset: 0; }\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "wave-distort"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.01 0.05",
    numOctaves: 2,
    result: "noise"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "baseFrequency",
    values: "0.01 0.05; 0.02 0.1; 0.01 0.05",
    dur: "0.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "SourceGraphic",
    in2: "noise",
    scale: 10
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "split-mask"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 800,
    height: 90
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "0; 10; -5; 0",
    dur: "0.1s",
    repeatCount: 1,
    begin: "glitch-trigger.begin"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 110,
    width: 800,
    height: 90
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "110; 100; 115; 110",
    dur: "0.1s",
    repeatCount: 1,
    begin: "glitch-trigger.begin"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "bg-matrix"
  }, /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 200",
    dur: "10s",
    repeatCount: "indefinite"
  }), "\n      1010110100101010110... ", /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    dy: 15
  }, "0011010101101010101..."), /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    dy: 15
  }, "1101010101010110101...")), /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "0 200",
    dur: "8s",
    repeatCount: "indefinite"
  }), "\n      0x8F 0x22 0xA1 0xDD... ", /*#__PURE__*/React.createElement("tspan", {
    x: 700,
    dy: 15
  }, "0xCC 0x11 0x00 0xFF..."), /*#__PURE__*/React.createElement("tspan", {
    x: 700,
    dy: 15
  }, "0xAA 0xBB 0xCC 0xDD...")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 100 H 150 L 180 130 H 300 M 500 130 H 620 L 650 100 H 800",
    className: "circuit"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,1000; 1000,0",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 130,
    r: 2,
    className: "circuit"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 130,
    r: 2,
    className: "circuit"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 130)",
    className: "distort glow"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    className: "title-text layer-cyan"
  }, "OVERWRITE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    className: "title-text layer-red"
  }, "OVERWRITE")), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    className: "title-text",
    style: {
      fill: "white",
      filter: "brightness(1.2)"
    }
  }, "OVERWRITE"), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -400,
    y: -80,
    width: 800,
    height: 2,
    fill: "#06b6d4",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    from: -80,
    to: 20,
    dur: "3s",
    repeatCount: "indefinite"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 160,
    x2: 700,
    y2: 40,
    className: "stutter-slash"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#06b6d4",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 50,
    x2: 100,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 50,
    x2: 50,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 750,
    y1: 50,
    x2: 700,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 750,
    y1: 50,
    x2: 750,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 150,
    x2: 100,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 150,
    x2: 50,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 750,
    y1: 150,
    x2: 700,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    x1: 750,
    y1: 150,
    x2: 750,
    y2: 100
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "glitch-trigger",
    width: 1,
    height: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    from: 1,
    to: 1,
    dur: "2s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverwriteTitle);
export default __webpack_public_path__ + "static/media/overwrite_title.f7de41e81a36f1b1aedac5b2bfcb2fe8.svg";
export { ForwardRef as ReactComponent };